import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import {
    Form,
    Button,
    Col,
    Dropdown,
    Modal,
    NavLink,
    Row,
} from "react-bootstrap";
import DeleteIcon from '@mui/icons-material/Delete';

import { ChevronDown } from "react-feather";
import UploadFileSharpIcon from "@mui/icons-material/UploadFileSharp";
import axios from "../../API/axios";
import defaultImage from "../../../src/assets/images/Default_user_image.png";
import DataTable from "react-data-table-component";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import SearchIcon from "@mui/icons-material/Search";
import EditIcon from "@mui/icons-material/Edit";
import Tooltip from "@mui/material/Tooltip";
import NoteAddSharpIcon from "@mui/icons-material/NoteAddSharp";
import InsertDriveFileSharpIcon from '@mui/icons-material/InsertDriveFileSharp';
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";
import { customStyles } from "../../selectStyles";
import ReactSelect from "react-select";
import GroupSharpIcon from "@mui/icons-material/GroupSharp";
import toast from "react-hot-toast";
import { ShimmerDiv } from "shimmer-effects-react";
import error from "../../assets/images/Not-Found.png";
import AssignmentSharpIcon from '@mui/icons-material/AssignmentSharp';
import Flatpickr from "react-flatpickr";
import moment from "moment";
// import axios from "../../API/axios";


const InstituteAssignedTest = () => {

    const sessionId = localStorage.getItem("sessionId");
    const [fileName, setFileName] = useState(""); // State to store selected filename
    const fileInputRef = useRef(null); // Reference to hidden file input
    const userUID = localStorage.getItem("userUID");
    const [candidateList, setCandidateList] = useState([]);
    const [search, setSearch] = useState("");
    const [filteredJobs, setFilteredJobs] = useState([]);

    const [display, setDisplay] = useState(false);
    const [page, setPage] = useState(1);
    const [classGroupBatch, setClassGroupBatch] = useState("All");
    const [groupBatchType, setGroupBatchType] = useState("All"); // going batch type
    const [groupBatchId, setGroupBatchId] = useState(null); // going batch id
    const [show, setShow] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);
    console.log("candidateList", candidateList);

    const [selectedCandidateClass, setSelectedCandidateClass] = useState(null); // State for selected class in modal
    const [selectedCandidateBatch, setSelectedCandidateBatch] = useState([]); // State for selected batch in modal
    const [candidateData, setCandidateData] = useState({}); // State for selected batch in modal
    // const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalRows, setTotalRows] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [classList, setClassList] = useState([]); // State to store class options
    const [selectedClass, setSelectedClass] = useState([]); // State for selected class
    const [batchList, setBatchList] = useState([]); // State to store batch options
    const [selectedBatch, setSelectedBatch] = useState(null); // State for selected batch
    const [unAuthorizeError, setUnAuthorizeError] = useState("");
    const [unauthModal, setUnauthModal] = useState(false);
    const handleunauthModal = () => setUnauthModal(true);
    const handlecloseunauthModal = () => setUnauthModal(false);

    // Assigned test 

    const [testRemark, setTestRemark] = useState("");
    const [testName, setTestName] = useState("");
    const [testType, setTestType] = useState([]);
    const [testTypeList, setTestTypeList] = useState(null);
    const [testLink, setTestLink] = useState("");
    const [testPlatform, setTestPlatform] = useState("");
    // const [platform, setplatform] = useState(null);
    const [testDuration, setTestDuration] = useState(null);
    const [testSchedule, setTestSchedule] = useState("");
    const [testInstruction, setTestInstruction] = useState("");
    const [jobappId, setjobappId] = useState(null);
    const [jobappNameId, setjobappNameId] = useState("");
    const [candidateId, setCandidateId] = useState("");

    console.log("candidateList", candidateList);


    const [showtestModal, setShowTestModal] = useState(false);
    const handleTestShow = (insttCnddtID, testID) => {
        // console.log("institute id", id);

        // setCandidateId(id);
        setShowTestModal(true);
        TestInfo(insttCnddtID, testID);
    };
    const handleCloseTestModal = () => setShowTestModal(false);

    const [allCandidates, setAllCandidates] = useState([]);


    const getGetAllAssignedCandidate = (page) => {
        setIsLoading(true);
        const data = {
            sessionId: sessionId,
            pageNumber: page,
            pageSize: 10,
        };
        axios
            .post(
                `/Institute/GetAllAssignedTest?SearchKey=${search}`,
                data
            )
            .then((response) => {
                console.log("inst test", response);

                console.log("inst candidate data", response.data.responseData.candidateTestInfoList);

                // const res = response?.data?.responseData || {};
                // setCandidateList(res?.candidateTestInfoList || []);
                const res = response?.data?.responseData || {};
                const fullList = res?.candidateTestInfoList || [];
                setAllCandidates(fullList);        // Master copy
                setCandidateList(fullList);
                setTotalRows(res?.paging?.totalrecords || 1);
                // setIsError(res.length === 0); // If no jobs, set error state
                setIsError(fullList.length === 0);
                setIsLoading(false);
            })
            .catch((error) => {
                console.error(error);
                setIsError(true);
                setIsLoading(false);
                if (error.response && error.response.status === 409) {
                    setUnAuthorizeError(error.response.data.message)
                    handleunauthModal()
                } else {
                    console.log("error", error);
                }
            });
    };

    useEffect(() => {
        getGetAllAssignedCandidate(currentPage);
    }, [search, currentPage])

    useEffect(() => {
        if (!search) {
            // If search input is cleared, reset to full list
            setCandidateList(allCandidates);
            setIsError(allCandidates.length === 0);
        } else {
            const filtered = allCandidates.filter((job) =>
            (job?.cnddtName?.toLowerCase().includes(search.toLowerCase()) ||
                job?.testName?.toLowerCase().includes(search.toLowerCase()))
            );
            setCandidateList(filtered);
            setIsError(filtered.length === 0); // Show error if nothing matches
        }
    }, [search, allCandidates]);


    const [testId, setTestId] = useState(null);
    const [InstCandidId, setInstCandidId] = useState(null);

    const UpdateTestAsign = async () => {

        try {
            const urlPattern = /^(https?:\/\/)?([\w\d.-]+)\.([a-zA-Z]{2,})(:[0-9]+)?(\/.*)?$/;
            if (!urlPattern.test(testLink)) {
                toast.error("Please enter a valid Test Link!");
                return;
            }
            const requestBody = {
                sessionId: sessionId,
                instnCnddtId: InstCandidId,
                cnddtType: "InsttCandidate",
                testName: testName,
                testType: testType,
                testDurationMinutes: testDuration,
                scheduledAt: testSchedule,
                platform: platform,
                link: testLink,
                testInstructions: testInstruction,
                remark: testRemark,
                testID: testId,

            };
            console.log("testdetail", requestBody);
            const response = await axios.post(
                "/Institute/UpdateTestAssignment",
                requestBody
            );
            toast.success(response.data.message)
            getGetAllAssignedCandidate();
            handleCloseTestModal();
            setTestType("");
            setTestName("");
            setTestRemark("");
            setTestInstruction("");
            setTestDuration(null);
            setTestSchedule("");
            setPlatform(null);
            setTestLink("");
        } catch (error) {
            toast.error(error.response.data.message);
            handleCloseTestModal();

            // toast.error("Some problem occurred!");
            console.error("API Error:", error);
        }
    };

    const [platform, setPlatform] = useState(null);
    const [platFormList, setPlatFormList] = useState([])

    const handleTestType = (selectedOption) => {
        console.log("Selected Test Type", selectedOption);
        setTestType(selectedOption.value); // Dropdown options clear karein
        console.log("Selected Test Type:", selectedOption.value);
    };
    const getplatformList = async () => {
        try {
            const response = await axios.get(`/MasterDDL/GetOnlineProctoringPlatformDDL`)
            console.log("platform==>", response)
            const platformOption = response.data.responseData.map((val) => ({
                value: val.id,
                label: val.name,
            }));
            setPlatFormList(platformOption)
        }
        catch (error) {
            console.log("GetList==>", error);
        }
    }

    const handlePlatform = (selectedOption) => {
        setPlatform(selectedOption.value);
    };

    const getTestTypeList = async () => {
        try {
            const response = await axios.get(`/MasterDDL/GetCandidateAssignTestTypesDDL`)
            //   console.log("GetList==>",response)
            const TestTypeOption = response.data.responseData.map((val) => ({
                value: val.id,
                label: val.name,
            }));
            setTestTypeList(TestTypeOption)
        }
        catch (error) {
            console.log("GetList==>", error);
        }
    }

    useEffect(() => {
        getTestTypeList();
        getplatformList();
    }, [])


    // ...........detele test .................

    const [showDeletetestModal, setDeleteTestModal] = useState(false);
    const handleTestDeleteShow = () => setDeleteTestModal(true);
    const handleCloseDeleteTestModal = () => setDeleteTestModal(false);


    const TestDelete = async () => {
        try {
            const requestBody = {
                sessionId: sessionId,
                instnCnddtId: InstCandidId,
                testID: testId,
                delete: true,
                status: null
            };
            console.log("testdetail", requestBody);

            const response = await axios.post(
                "/Institute/AssignedTestAction",
                requestBody
            );

            toast.success(response.data.message)
            getGetAllAssignedCandidate();

            handleCloseDeleteTestModal();

        } catch (error) {
            toast.error(error.response.data.message);
            handleCloseDeleteTestModal();

        }
    };

    const TestInfo = async (insttCnddtID, testID) => {

        const data = {
            sessionId: sessionId,
            instnCnddtId: insttCnddtID,
            testID: testID,
        };
        console.log("data===>", data);

        try {
            await axios.post("/Institute/GetAssignedTestInfo", data).then((resData) => {
                console.log("HISTORY", resData.data.responseData);
                const data = resData.data.responseData;

                console.log("data1", data);
                setTestType(data.testType);
                setTestName(data.testName);
                setTestRemark(data.remark);
                setTestInstruction(data.testInstructions);
                setTestDuration(data.testDurationMinutes);
               // setTestSchedule(data.scheduledAt);
                const localMoment = moment.utc(data.scheduledAt).local();
                setTestSchedule(localMoment.format("YYYY-MM-DDTHH:mm"));
                setPlatform(data.platform);
                setTestLink(data.link);
            });
        } catch (e) {
            console.log("Unapply ");
        }
    };




    const columns = [
        {
            name: "ASSIGN DATE",
            center: true,
            sortable: true,
            minWidth: "150px",
            //   selector: (row) => row.jbApplctnTypeName,
            cell: (row) => (
                <>
                    <div className="d-flex">
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                            }}
                        >
                            <div className="date-box">
                                <div className="month text-center">
                                    {" "}
                                    {moment(row.scheduledAt).format("MMM YYYY").toUpperCase()}
                                </div>
                                <div className="day text-center"> {moment(row.scheduledAt).format("DD")}</div>
                            </div>
                            <p className="mb-1 mt-2"><span className="f-600">Time : </span>{moment.utc(row.scheduledAt).local().format("hh : mm  A")} </p>
                        </div>
                    </div>
                </>
            ),
        },

        {
            name: "TEST DETAILS",
            // center: true,
            sortable: true,
            minWidth: "200px",
            cell: (row) => (
                <>
                    <div
                        className="pt-2 pb-2"
                        style={{
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        {row.testName === "" ? "" : (<>
                            <p className="mb-1"><span className="f-600">Test Name: </span>{row.testName}</p>
                        </>)}
                        {row.testDurationMinutes === null ? "" : (<>
                            <p className="mb-1"><span className="f-600">Test Duration : </span>{row.testDurationMinutes} Minutes</p>
                        </>)}
                        {/* {row.remark === null ? "" : ( */}
                            <>
                            <p className="mb-1"> <span className="f-600">Remark : </span> {row.remark}</p>
                        </>
                    {/* )} */}
                        {row.platform === "" ? "" : (<>
                            <p className="mb-1"> <span className="f-600">Platform : </span> {platFormList.find(
                                (platform) => platform.value === row.platform
                            )?.label || row.platform}</p>
                        </>)}
                        {row.link === null ? "" : (<>
                            {/* <p className="mb-1"> <span className="f-600">Link : </span> {row.link}</p> */}
                            <p className="mb-1" style={{ maxWidth: '200px', wordBreak: 'break-word', whiteSpace: 'normal' }}>
                                <span className="f-600">Link : </span>
                                <span>{row.link}</span>
                            </p>
                        </>)}
                        {/* {row.testInstructions === null ? "" : ( */}
                            <>
                            <p className="mb-1"> <span className="f-600">Instruction : </span> {row.testInstructions}</p>
                        </>
                        {/* )} */}
                    </div>
                </>
            ),
        },
        {
            name: "CANDIDATES",
            sortable: true,
            center: true,
            cell: (row) => (
                <div className="mt-2 mb-2" style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "5px" }}>

                    <div className="AssignCandid"
                        style={{
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "column",

                        }}
                    >
                        <img
                            src={row?.cnddtProfilePic}
                            alt="User"
                            style={{ width: "50px", height: "50px", borderRadius: "50%" }}
                        />
                        <div className="f-600 mt-1 user">
                            <Link
                                to={`/Candidate/${row.cnddtUid}`}>
                                {row.cnddtName}
                            </Link>
                        </div>
                        <div className="f-600 mt-1 text-center">
                            <Link
                                to={`/job/${row?.jobID}`}
                                className=" "  >
                                {row?.jobTitle}
                            </Link>

                        </div>

                    </div>


                </div>
            ),
        },

        {
            name: "Action",
            center: true,
            sortable: true,
            minWidth: "150px",
            cell: (row) => (
                <>
                    <div className="d-block">
                        <span className="ms-2 ">
                            <Tooltip title="Update Assign Test" arrow>
                                <EditIcon
                                    onClick={() => {
                                        handleTestShow(row?.insttCnddtID, row?.testID);
                                        setInstCandidId(row?.insttCnddtID);
                                        setTestId(row?.testID);
                                    }}
                                    className="blueIcon" />
                            </Tooltip>
                        </span>

                        <span>
                            <Tooltip title="Delete Test" arrow>
                                <DeleteIcon
                                    className="pointer rejectIcon"
                                    onClick={() => {
                                        handleTestDeleteShow();
                                        setInstCandidId(row?.insttCnddtID);
                                        setTestId(row?.testID);
                                    }}
                                />
                            </Tooltip>
                        </span>
                    </div>
                </>
            ),
        },
    ];

    // useEffect(() => {
    //     const filteredData = candidateList.filter((job) =>
    //         job.cnddtName.toLowerCase().includes(search.toLowerCase()) // Adjust 'title' as per job data
    //     );
    //     setFilteredJobs(filteredData);
    // }, [search, candidateList]); // Run effect when search or jobList changes

    return (
        <>
            <section className="pricing-section-three container interviews jobapplication bulkResume view-job-style application-drop-section ">
                <div className="d-flex justify-content-between">
                    <div className="mt-2 w-50">
                        <h4 className="orange-title">
                            <span className="orange-box me-2"></span>
                         Assigned Test List
                        </h4>
                    </div>
                    <div className="manage-search-bar w-25 instituteSearchCont">
                        <SearchIcon className="icon" />
                        <input
                            type="text"
                            placeholder="Search..."
                            className="manage-search-input"
                            onChange={(e) => setSearch(e.target.value.trim().toLowerCase())}

                        />
                    </div>
                </div>

                <div className="container st3">


                    {/* {isLoading && candidateList.length > 0 ? ( */}
                    {isLoading ?
                        (<div className="row mt-2">
                            <div className="col-md-12 mb-1">
                                <ShimmerDiv mode="light" height={100} width={"100%"} />
                            </div>
                            <div className="col-md-12 mb-1">
                                <ShimmerDiv mode="light" height={100} width={"100%"} />
                            </div>
                            <div className="col-md-12 mb-1">
                                <ShimmerDiv mode="light" height={100} width={"100%"} />
                            </div>
                        </div>
                        )
                        : isError && candidateList.length === 0 ? (
                            <div className="mt-2 error-image-cont error-cont d-flex justify-content-center">
                                <img src={error} alt="404 Not Found" width={300} />
                            </div>
                        )
                            : classGroupBatch === "Class" && !selectedClass ? (
                                <div className="mt-2 error-image-cont error-cont justify-content-center">
                                    <p className="d-flex justify-content-center">Select a class first.</p>
                                </div>
                            ) : classGroupBatch === "Batch" && !selectedBatch ? (
                                <div className="mt-2 error-image-cont error-cont justify-content-center">
                                    <p className="d-flex justify-content-center">Select a batch first.</p>
                                </div>
                            ) : isError && candidateList.length === 0 ? (
                                <div className="mt-2 error-image-cont error-cont d-flex justify-content-center">
                                    {/* <p className="d-flex justify-content-center">There is no record to display</p> */}
                                    <img src={error} alt="404 Not Found" width={300} />
                                </div>
                            )
                                : isError || candidateList.length === 0 ? (
                                    <div className="mt-2 error-image-cont error-cont d-flex justify-content-center">
                                        {/* <img src='/' alt="404 Not Found" width={200} /> */}
                                        <img src={error} alt="404 Not Found" width={300} />

                                    </div>
                                )
                                    : (
                                        <div className="scroll-react-dataTable">
                                            <div className="react-dataTable react-table-colorclass">
                                                <DataTable
                                                    noHeader
                                                    pagination
                                                    columns={columns}
                                                    data={candidateList}
                                                    progressPending={isLoading}
                                                    paginationServer
                                                    paginationPerPage={10}
                                                    paginationTotalRows={totalRows}
                                                    paginationDefaultPage={currentPage}
                                                    paginationRowsPerPageOptions={[]}
                                                    // onChangePage={(page) => {
                                                    // 	getGetAllCandidate(page);
                                                    // }}
                                                    onChangePage={(page) => {
                                                        setCurrentPage(page); // Update the current page
                                                    }}
                                                    sortIcon={<ChevronDown size={10} />}
                                                    className="react-dataTable"
                                                    noDataComponent={
                                                        <div className="mt-2 error-image-cont error-cont d-flex justify-content-center">
                                                            <p className="d-flex justify-content-center">There is no record to display</p>
                                                        </div>
                                                    }
                                                />
                                            </div>
                                        </div>

                                    )}
                </div>
            </section>

            <Modal show={showtestModal} onHide={handleCloseTestModal} centered size="lg">
                <Modal.Header>
                    <Modal.Title>Update Assign Test</Modal.Title>
                    <CloseSharpIcon className="pointer" onClick={handleCloseTestModal} />
                </Modal.Header>
                <Modal.Body>

                    <div className="row  mt-2 align-center">

                        <Col md={6} className="mb-2">
                            <div className="post-form-group">
                                <label htmlFor="about" className="f-14 f-700">
                                    Test Name<span style={{ color: "red" }} className="ms-2">
                                        *
                                    </span>
                                </label>
                                <input
                                    placeholder="Enter Test Name"
                                    type="text"
                                    style={{ width: "100%" }}
                                    value={testName}
                                    onChange={(e) => setTestName(e.target.value)}
                                />
                            </div>
                        </Col>
                        <Col md={6} className="mb-2">
                            <div className="post-form-group text-transform-email">
                                <label htmlFor="about" className="f-14 f-700">
                                    Link<span style={{ color: "red" }} className="ms-2">
                                        *
                                    </span>
                                </label>
                                <input
                                    placeholder="Enter Link"
                                    type="text"
                                    style={{ width: "100%" }}
                                    value={testLink}
                                    onChange={(e) => setTestLink(e.target.value)}
                                />
                            </div>
                        </Col>

                        <Col md={6} className="mb-2">
                            <div className="post-form-group">
                                <label htmlFor="about" className="f-14 f-700">
                                    Test Type<span style={{ color: "red" }} className="ms-2">
                                        *
                                    </span>
                                </label>

                                <ReactSelect
                                    options={testTypeList}
                                    onChange={handleTestType} // Select hone ke baad clear ho jaye
                                    placeholder="Enter Test Type"
                                    // value={testTypeList.find(option => option.value === testType) || null}
                                    value={(Array.isArray(testTypeList) ? testTypeList?.find(option => option.value === testType) : null)}
                                    classNamePrefix="react-select"
                                    className="form-control Dark-Input-from-group"
                                    styles={customStyles}
                                    isClearable
                                />
                            </div>
                        </Col>
                        <Col md={6} className="mb-2">
                            <div className="post-form-group">
                                <label htmlFor="about" className="f-14 f-700">
                                    Platform<span style={{ color: "red" }} className="ms-2">
                                        *
                                    </span>
                                </label>
                                <ReactSelect
                                    options={platFormList}
                                    onChange={handlePlatform} // Select hone ke baad clear ho jaye
                                    placeholder="Enter Platform"
                                    value={platFormList.find(option => option.value === platform) || null} classNamePrefix="react-select"
                                    className="form-control Dark-Input-from-group"
                                    styles={customStyles}
                                    isClearable
                                />
                            </div>
                        </Col>


                        <Col md={6} className="mb-2">
                            <div className="post-form-group">
                                <label htmlFor="about" className="f-14 f-700">
                                    Test Duration Minutes<span style={{ color: "red" }} className="ms-2">
                                        *
                                    </span>
                                </label>
                                <input
                                    placeholder="Enter Test Duration "
                                    type="text"
                                    style={{ width: "100%" }}
                                    value={testDuration}
                                    onChange={(e) => setTestDuration(e.target.value)}
                                // onChange={handleChange}

                                />
                            </div>
                        </Col>
                        <Col md={6} className="mb-2">
                            <div className="post-form-group">
                                <label htmlFor="about">
                                    Schedule Time<span style={{ color: "red" }} className="ms-2">
                                        *
                                    </span>
                                </label>
                                <Flatpickr
                                    data-enable-time
                                    value={testSchedule}
                                    onChange={(selectedDates) => {
                                        setTestSchedule(selectedDates[0]);
                                    }}
                                    options={{
                                        enableTime: true,
                                        dateFormat: "Y-m-d H:i",
                                        minDate: new Date(),
                                        static: true, // Keeps the calendar visible on click         
                                    }}
                                    className="form-control Dark-Input-from-group"
                                    placeholder="Enter schedule time"
                                />
                            </div>
                        </Col>
                        <Col md={12} className="mb-2">
                            <div className="post-form-group">
                                <label htmlFor="about" className="f-14 f-700">
                                    Remark
                                </label>
                                <textarea
                                    placeholder="Enter Remark"
                                    type="text"
                                    style={{ width: "100%" }}
                                    value={testRemark}
                                    onChange={(e) => setTestRemark(e.target.value)}
                                />
                            </div>
                        </Col>
                    </div>
                    <div className="row">

                        <Col md={12} className="mb-2">
                            <div className="post-form-group">
                                <label htmlFor="about" className="f-14 f-700">
                                    Instructions
                                </label>
                                <textarea
                                    placeholder="Enter Instruction"
                                    type="text"
                                    style={{ width: "100%" }}
                                    value={testInstruction}
                                    onChange={(e) => setTestInstruction(e.target.value)}
                                />
                            </div>
                        </Col>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        className="btn khojPrimaryBtn test-assign-khojPrimaryBtn"

                        onClick={() => {

                            UpdateTestAsign();

                        }}
                    >
                        Submit
                    </button>
                </Modal.Footer>
            </Modal>

            {/* {/.................................... delete test Modal end ................................/} */}

            <Modal show={showDeletetestModal} onHide={handleCloseDeleteTestModal} centered>
                <Modal.Header>
                    <Modal.Title>Confirm delete</Modal.Title>
                    <CloseSharpIcon className="pointer" onClick={handleCloseDeleteTestModal} />
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <p>Are you sure you want to delete.</p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        className="btn btn-danger"

                        onClick={() => {
                            TestDelete();
                        }}
                    >
                        Confirm
                    </button>
                </Modal.Footer>

            </Modal>


        </>
    );
};

export default InstituteAssignedTest;
